<div class="date-range">
  <h4 *ngIf="dateRangeTitle" class="date-range__title text text_{{titleSize}}">{{ dateRangeTitle }}</h4>
  <div class="date-range__dates text text_{{dateSize}} text_{{dateWeight}}">{{startDate | luxon: 'dd.MM.yyyy'}} — {{endDate | luxon: 'dd.MM.yyyy'}}</div>
</div>
